import { ArrowRight, Check } from "lucide-react";
import { CTA } from "@/constants/testIds";

const audits = [
  "Website presence check",
  "Landing page conversion review",
  "SEO visibility check",
  "Paid ads gap analysis",
  "Lead funnel review",
  "AI automation opportunities",
];

export default function AuditSection() {
  return (
    <section id="audit" className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="rounded-3xl border border-blue-100 bg-gradient-to-br from-blue-50 via-white to-white p-8 md:p-14 reveal">
          <div className="grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="text-xs font-bold uppercase tracking-widest text-blue-600">Free Growth Audit</div>
              <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold text-slate-900 tracking-tight">
                Get a free, no-obligation audit of your marketing.
              </h2>
              <p className="mt-4 text-slate-600 text-base md:text-lg leading-relaxed max-w-2xl">
                I&apos;ll personally review your website, ads and funnel — and share exactly where you&apos;re
                leaking traffic, leads and revenue, plus what to fix first.
              </p>
              <a
                href="#free-audit-form"
                data-testid={CTA.auditSectionCta}
                className="mt-8 inline-flex items-center gap-2 bg-blue-600 text-white hover:bg-blue-700 font-semibold py-4 px-7 rounded-full transition-all shadow-lg shadow-blue-600/20 active:scale-95"
              >
                Book My Free Growth Audit <ArrowRight className="w-4 h-4" />
              </a>
            </div>
            <div className="lg:col-span-5">
              <div className="grid grid-cols-1 gap-3">
                {audits.map((a, i) => (
                  <div
                    key={i}
                    className="flex items-start gap-3 bg-white rounded-xl border border-slate-200 p-3.5"
                  >
                    <div className="w-6 h-6 rounded-full bg-blue-600 text-white grid place-items-center shrink-0">
                      <Check className="w-3.5 h-3.5" />
                    </div>
                    <span
                      className="text-sm text-slate-700"
                      dangerouslySetInnerHTML={{ __html: a }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
